var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{attrs:{"label":_vm.$t('text'),"disabled":_vm.disabled,"rules":[_vm.notEmpty],"counter":"","no-resize":"","id":"observation-text","rows":"5"},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }